/** Copy of "Povinnosti a práva řemeslníka" for the quiz dashboard, the quiz tabs and the header menu on bidmio.cz. */
export const CS_RIGHTS_SITE_QUIZ = {
  title: 'Povinnosti a práva řemeslníka',
  description:
    'Nejvýš šest rychlých otázek a uvidíte jen to, co se týká vás: DPH, paušální daň, EET 2.0 od roku 2027, pojištění, zaměstnanci a smlouvy, i na co máte nárok. U každého bodu je zdroj.',
  short: 'Povinnosti a práva',
  menuLabel: 'Jaké povinnosti a práva máte jako řemeslník?',
};
